export default "__VITE_ASSET__451d725c__"